export default __webpack_public_path__ + "static/Денежный поток 3-ad82b5ae7bea1a4ae79d4902e85108a9.jpg";